import { memo } from 'react';

import EnterprisePlanIconSVG from '@/assets/enterprise-plan-icon.svg?react';
import IndividualPlanIconSVG from '@/assets/individual-plan-icon.svg?react';
import TeamPlanIconSVG from '@/assets/team-plan-icon.svg?react';
import { merge } from '@/components';
import { Logo, LogoProps } from '@/components/core';

export type PaymentPlanLogoProps = LogoProps & { planId?: string | null };

const IPaymentPlanLogo = ({ planId, className, ...rest }: PaymentPlanLogoProps) => {
  let style;
  let planIcon;

  if (planId?.includes('individual')) {
    planIcon = <IndividualPlanIconSVG />;
    style = 'text-[#15B79E]';
  } else if (planId?.includes('team')) {
    planIcon = <TeamPlanIconSVG />;
    style = 'text-[#06AED4]';
  } else if (planId?.includes('enterprise')) {
    planIcon = <EnterprisePlanIconSVG />;
    style = 'text-gray-700';
  }

  return (
    <Logo className={merge(style, className)} {...rest}>
      {planIcon}
    </Logo>
  );
};

export const PaymentPlanLogo = memo(IPaymentPlanLogo) as typeof IPaymentPlanLogo;
